import { type TranslationTree } from '@/i18n/types';

export const messages = {
  role: {
    owner: 'Responsável',
    editor: 'Edição',
    viewer: 'Leitura',
  },
} satisfies TranslationTree;
